import { Component, Input } from "@angular/core";
import {
  DEFAULT_RANGE_PERIOD_FILTER_DATA,
  DEFAULT_SINGLE_PERIOD_FILTER_DATA,
} from "@va/core-library/period-filter";
@Component({
  selector: "app-create-new-charts-wizard",
  templateUrl: "./create-new-charts-wizard.component.html",
  styleUrls: ["./create-new-charts-wizard.component.scss"],
})
export class CreateNewChartsWizardComponent {
  @Input() currentIndex = 0;
  @Input() addRowTableData: Array<any>;
  @Input() userChartId: string;
  @Input() watchlists: Array<any>;
  @Input() recentlyVisitedCompanies: Array<any>;
  @Input() addColTableData: Array<any>;
  @Input() title: string;
  @Input() createPeriod: Array<string>;
  @Input() filterData: any;
  context: string;
  mpt: number = null;
  tickers = [];
  createLiDataFetch = false;
  stdLineItems: Array<any> = [];
  chartName = "";
  revision = "12m";
  yearTypeData: any = null;

  setContext(context: string) {
    this.context = context;
    if (context === "Comparison" || context === "line") {
      this.yearTypeData = DEFAULT_SINGLE_PERIOD_FILTER_DATA;
    } else {
      this.yearTypeData = {
        ...DEFAULT_RANGE_PERIOD_FILTER_DATA,
        other_period: [],
      };
    }
    this.currentIndex = 1;
  }

  moveToNextStep() {
    if (this.currentIndex < 3) {
      this.currentIndex++;
    }
  }

  moveToPreviousStep() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  onMptUpdate(mpt) {
    this.mpt = mpt;
  }

  tickerUpdate(tickerData) {
    this.addRowTableData = tickerData;
  }

  onUpdateChart(liData) {
    this.addColTableData = liData;
  }

  updateChartName(chartName) {
    this.chartName = chartName;
  }

  updateEstimate(period) {
    this.createPeriod = period;
  }

  updateRevision(revision) {
    this.revision = revision;
  }

  updateYearType(data) {
    this.yearTypeData = data.updatedPeriodData;
  }
}
